import { Fulfillment, Logistics } from "@secondcloset/types";

import { APIVersion, getAPIFromDomain } from "../../lib/api";

export const fetchShipmentAvailabilities = async (body: Record<string, unknown>): Promise<Logistics.Availability[]> => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/shipments/availabilities`;
  const response = await api.post(url, body);
  return response.data;
};

export const createShipment = async (request: Record<string, unknown>): Promise<Fulfillment.Shipment> => {
  const { version = 1, ...payload } = request;
  const api = getAPIFromDomain("fulfillment", version as APIVersion);
  const url = `/shipments`;
  const response = await api.post(url, payload);
  return response.data;
};

interface RecreateShipmentBody {
  shipment_id: string;
  order_id: string;
  date: string;
  time_range: string;
}

export type RecreateShipment = (body: RecreateShipmentBody) => Promise<Fulfillment.Shipment>;
export const recreateShipment: RecreateShipment = async (body) => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/shipments/recreate`;
  const response = await api.post(url, body);
  return response.data;
};

interface FetchShipmentRatesBody {
  order_item_ids: string[];
  job_type: string;
  include_default_carriers: boolean;
  provider_scope?: string[];
  packages?: unknown[];
  ship_to_address_id?: string;
}

export const fetchShipmentRates = async ({
  orderID,
  body,
}: {
  orderID: string;
  body: FetchShipmentRatesBody;
}): Promise<{
  errors: string[];
  rates: Logistics.ShippingRate[];
}> => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/orders/${orderID}/shipping_rates`;
  const response = await api.post(url, body);
  return response.data;
};

export const updateShipmentMethod = async (options: Record<string, unknown>) => {
  const { shipmentID, body } = options;
  const api = getAPIFromDomain("fulfillment");
  const url = `/shipments/${shipmentID}/update_shipping_method`;
  const response = await api.put(url, body);
  return response.data;
};

export const updateShipmentStatus = async ({
  shipmentID,
  status,
}: {
  shipmentID: string;
  status: Fulfillment.Shipment["shipping_method"]["status"];
}) => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/shipments/${shipmentID}/${status}`;
  const response = await api.put(url);
  return response.data;
};

export const createPickSheet = ({ shipmentID }: { shipmentID: string }) => {
  const api = getAPIFromDomain("fulfillment");
  const url = `/shipments/${shipmentID}/push_warehouse_work_order`;
  return api.post(url);
};

type TrackingInfo = { lot_number: number; serial_number: number; quantity: number };
type ShipmentItems = Fulfillment.ShipmentItem<"V2"> & { tracking_info: TrackingInfo[] };
export const fetchShipmentItems = async (shipmentId: string): Promise<ShipmentItems[]> => {
  const api = getAPIFromDomain("logistics", 2);
  const url = `/shipments/${shipmentId}/items`;
  const res = await api.get(url);
  return res.data;
};
